var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "root-container"
    }
  }, [_c('div', {
    staticClass: "focusable",
    style: {
      marginBottom: _vm.isLastKey ? '10px' : '0px'
    },
    attrs: {
      "id": "graph-range-input-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "graph-range-input-background-container"
    }
  }, [_c('div', {
    style: {
      backgroundColor: _vm.barColor,
      width: _vm.stepComplete,
      height: '65px'
    },
    attrs: {
      "id": "graph-range-input-background"
    }
  })]), _c('input', {
    ref: "rangeInput",
    style: {
      '--icon-position-correction': _vm.iconPositionCorrection
    },
    attrs: {
      "aria-label": _vm.ariaLabel,
      "disabled": _vm.isDisabled,
      "id": ((_vm.label) + "_"),
      "max": _vm.xAxisData.maxValue,
      "min": _vm.xAxisData.minValue,
      "step": _vm.xAxisData.increment,
      "type": "range",
      "tabindex": "10"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onRangeSelectionChange,
      "focus": _vm.onRangeInputChange,
      "input": _vm.onRangeInputChange,
      "blur": _vm.onBlur
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }